import { cx } from "@jugl-web/utils";
import { CSSProperties, FC } from "react";
import { ChatButton } from "../ChatButton";
import { ReactComponent as PlaceholderIcon } from "./assets/placeholder.svg";

interface ProductCardProps {
  name: string;
  imageUrl: string | null;
  priceText: string;
  className?: string;
  style?: CSSProperties;
  onSelect?: () => void;
}

export const ProductCard: FC<ProductCardProps> = ({
  name,
  imageUrl,
  priceText,
  className,
  style,
  onSelect,
}) => {
  return (
    <div
      className={cx(
        "flex flex-col overflow-hidden rounded-2xl border border-solid border-dark-200 bg-white",
        className
      )}
      style={style}
    >
      <div className="h-[150px] w-full shrink-0 overflow-hidden border border-t-0 border-r-0 border-l-0 border-solid border-[#F2F2F2]">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-grey-100">
            <PlaceholderIcon className="shrink-0" />
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1.5 px-3 py-4">
        <span
          className="font-secondary text-sm leading-[150%] font-medium whitespace-normal text-dark"
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
          title={name}
        >
          {name}
        </span>
        <span className="font-secondary text-base leading-[140%] font-semibold text-dark">
          {priceText}
        </span>
      </div>
      {!!onSelect && (
        <>
          <div className="flex-1" />
          <div className="px-3 pt-3 pb-4">
            <ChatButton variant="primary" fullWidth onClick={onSelect}>
              Select
            </ChatButton>
          </div>
        </>
      )}
    </div>
  );
};
